import React from 'react';
import PageLayout from '../../UiKit/Wizard/Page/PageLayout';
import NavigationButton from '../../UiKit/Wizard/NavigationButton/NavigationButton';
import SubHeader from '../../UiKit/Wizard/SubHeader/SubHeader';
import Form from '../../UiKit/Form/Form';
import WizardLayout from '../../UiKit/Wizard/WizardLayout/WizardLayout';
import Body from '../../UiKit/Wizard/Body/Body';
import { translations } from './translations';
import { useLanguage } from '../../UiKit/Wizard/langugeContext';
import useTaxForm from '../../Hooks/useTaxForm';
import PdfIcon from '../../Images/Pdf.svg';
import downloadFileFromStream from '../../Utilities/downloadFileFromStream';
import { Pages } from './TaxFormWizard';

function TaxformDownloadPage({
    taxData,
    setCurrentPage,
    sendLoggingEventToBackend,
}) {
    const { closeTaxForm, resetTaxFormState } = useTaxForm();
    const { currentLanguage } = useLanguage();

    let selectedTaxForm = {};
    if (taxData && taxData.selectedTaxForm) {
        selectedTaxForm = taxData.selectedTaxForm;
    }

    let downloadLink = '';
    if (taxData && taxData.downloadData && taxData.downloadData.downloadLink) {
        downloadLink = taxData.downloadData.downloadLink;
    }

    let taxFormSubType = '';
    if (
        taxData &&
        taxData.availableTaxForms &&
        taxData.availableTaxForms.availableTaxForms
    ) {
        const matchingForm = taxData.availableTaxForms.availableTaxForms.find(
            (form) =>
                form.taxFormType === selectedTaxForm.taxFormType &&
                form.taxFormYear === parseInt(selectedTaxForm.taxFormYear, 10)
        );
        taxFormSubType = matchingForm ? matchingForm.taxFormSubType : '';
    }

    const handleDownload = async () => {
        try {
            if (
                taxData &&
                taxData.downloadData &&
                !taxData.downloadData.xAuthToken
            ) {
                sendLoggingEventToBackend({
                    intentName: 'tempLog',
                    text: 'downloadTaxFormError: xAuthToken is missing',
                });
            }
            if (
                taxData &&
                taxData.downloadData &&
                !taxData.downloadData.oamRemoteUser
            ) {
                sendLoggingEventToBackend({
                    intentName: 'tempLog',
                    text: 'downloadTaxFormError: oamRemoteUser is missing',
                });
            }
            if (
                taxData &&
                taxData.downloadData &&
                !taxData.downloadData.xAppId
            ) {
                sendLoggingEventToBackend({
                    intentName: 'tempLog',
                    text: 'downloadTaxFormError: xAppId is missing',
                });
            }

            const response = await fetch(
                `${taxData.downloadData.downloadLink}`,
                {
                    method: 'POST',
                    body: JSON.stringify({
                        ecmId: taxData.downloadData.ecmId,
                    }),
                    headers: {
                        'X-AUTH-TOKEN': taxData.downloadData.xAuthToken,
                        OAM_REMOTE_USER: taxData.downloadData.oamRemoteUser,
                        'X-APP-ID': taxData.downloadData.xAppId,
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (!response.ok) {
                const error = new Error('HTTP error');
                error.httpStatusCode = response.status;
                throw error;
            }

            sendLoggingEventToBackend({
                intentName:
                    currentLanguage === 'en'
                        ? 'TaxFormClickedForDownload'
                        : 'TaxFormClickedForDownloadSpanish',
                text:
                    currentLanguage === 'en'
                        ? 'TaxFormClickedForDownload'
                        : 'TaxFormClickedForDownloadSpanish',
            });
            await downloadFileFromStream(response);

            sendLoggingEventToBackend({
                intentName:
                    currentLanguage === 'en'
                        ? 'TaxFormDownloadedSuccessfully'
                        : 'TaxFormDownloadedSuccessfullySpanish',
                text:
                    currentLanguage === 'en'
                        ? 'Tax form was successfully downloaded'
                        : 'El formulario de impuestos se descargó con éxito',
            });
        } catch (error) {
            if (error.httpStatusCode === 401) {
                setCurrentPage(Pages.TAX_FROM_SESSION_EXPIRED);
                sendLoggingEventToBackend({
                    intentName:
                        currentLanguage === 'en'
                            ? 'TaxFormClickedForDownloadFailedSessionExpired'
                            : 'TaxFormClickedForDownloadFailedSessionExpiredSpanish',
                    text:
                        currentLanguage === 'en'
                            ? 'TaxFormClickedForDownloadFailedSessionExpired'
                            : 'TaxFormClickedForDownloadFailedSessionExpiredSpanish',
                });
                return;
            }
            if (error.httpStatusCode === 503) {
                setCurrentPage(Pages.TAX_FORM_SERVICE_UNAVAILABLE);
                sendLoggingEventToBackend({
                    intentName:
                        currentLanguage === 'en'
                            ? 'TaxFormClickedForDownloadFailedNoService'
                            : 'TaxFormClickedForDownloadFailedNoServiceSpanish',
                    text:
                        currentLanguage === 'en'
                            ? 'TaxFormClickedForDownloadFailedNoService'
                            : 'TaxFormClickedForDownloadFailedNoServiceSpanish',
                });
                return;
            }

            sendLoggingEventToBackend({
                intentName:
                    currentLanguage === 'en'
                        ? 'TaxFormClickedForDownloadFailedForbidden'
                        : 'TaxFormClickedForDownloadFailedForbiddenSpanish',
                text:
                    currentLanguage === 'en'
                        ? 'TaxFormClickedForDownloadFailedForbidden'
                        : 'TaxFormClickedForDownloadFailedForbiddenSpanish',
            });
            setCurrentPage(Pages.TAX_FORM_FORBIDDEN);
        }

        // var link = document.createElement('a');
        // document.body.appendChild(link);
        // link.href = pdfdata;
        // link.download = "form.pdf";
        // link.click();
        // window.URL.revokeObjectURL(pdfdata);
        // link.remove();

        // if (downloadLink) {
        //   const anchor = document.createElement("a");
        //   anchor.href = downloadLink;
        //   anchor.target = "_blank";
        //   anchor.download = "";
        //   document.body.appendChild(anchor);
        //   anchor.click();
        //   document.body.removeChild(anchor);
        //   sendLoggingEventToBackend({
        //     intentName:
        //       lang === "en"
        //         ? "TaxFormsDownloadAvailable"
        //         : "TaxFormsDownloadAvailable",
        //     text:
        //       lang === "en"
        //         ? "TaxFormsDownloadAvailable"
        //         : "TTaxFormsDownloadAvailableSpanish",
        //   });
        // } else {
        // }
    };

    const handleGetAnotherTaxForm = () => {
        resetTaxFormState();
        setCurrentPage(0);
    };

    // const { currentLanguage } = useLanguage();
    const downloadPageTranslations =
        translations[currentLanguage]['DownloadPage'];
    const NavButton = translations[currentLanguage]['NavButton'];

    return (
        <PageLayout>
            <PageLayout.Header>
                <SubHeader subHeader={downloadPageTranslations.subHeader} />
            </PageLayout.Header>
            <PageLayout.Content>
                <Body bodyText={<p>{downloadPageTranslations.bodyText}</p>} />

                {/* PDF Download Section */}
                <div style={{ margin: '32px 0', textAlign: 'center' }}>
                    <button
                        onClick={handleDownload}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            background: '#F1F6F9',
                            border: '1px solid #D1D1D1',
                            borderRadius: '8px',
                            padding: '16px',
                            cursor: 'pointer',
                            width: '100%',
                            textAlign: 'left',
                            gap: '12px',
                            paddingLeft: '40px',
                        }}
                    >
                        <img
                            src={PdfIcon}
                            alt="PDF Icon"
                            style={{ width: '32px', height: '54px' }}
                        />
                        <div>
                            <div
                                style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    textDecoration: 'underline',
                                    color: '#2d77a3',
                                }}
                            >
                                {`${selectedTaxForm.taxFormYear} ${selectedTaxForm.taxFormType}`}
                            </div>
                            <p
                                style={{
                                    fontSize: '14px',
                                    color: '#334048',
                                    fontFamily: 'Open Sans',
                                    fontStyle: 'normal',
                                    fontWeight: '400',
                                    lineHeight: '100%',
                                    margin: '4px 0 0 0',
                                    textDecoration: 'none',
                                }}
                            >
                                This will open a new tab.
                            </p>
                        </div>
                    </button>
                </div>

                <Body
                    bodyText={
                        <p>
                            {downloadPageTranslations.bodyText2}{' '}
                            <a
                                href="https://apply.coveredca.com/static/lw-web/login"
                                target="_blank"
                                style={{
                                    color: '#2d77a3',
                                    textDecoration: 'underline',
                                }}
                            >
                                {downloadPageTranslations.bodyText3}
                            </a>{' '}
                            {downloadPageTranslations.bodyText4}
                        </p>
                    }
                />
            </PageLayout.Content>

            <WizardLayout.Navigation>
                <NavigationButton onClick={closeTaxForm} type={'primary'}>
                    {NavButton.ExitButton}
                </NavigationButton>
                <NavigationButton
                    onClick={() => {
                        sendLoggingEventToBackend({
                            intentName:
                                currentLanguage === 'en'
                                    ? 'GetAnotherTaxForm'
                                    : 'GetAnotherTaxFormSpanish',
                            text:
                                currentLanguage === 'en'
                                    ? 'Get another tax form'
                                    : 'Get another tax form Spanish',
                        });
                        handleGetAnotherTaxForm();
                    }}
                    type={'secondary'}
                >
                    {downloadPageTranslations.getAnotherTaxForm}
                </NavigationButton>
            </WizardLayout.Navigation>
        </PageLayout>
    );
}

export default TaxformDownloadPage;
